<script setup>
import { computed, defineProps } from 'vue'

const props = defineProps({
  card: { type: Object, required: true },
  headerTag: { type: String, default: 'h3' }, // optional override
})

/** first media by field name ('image', 'hovered_image') */
const mediaByField = (field) => {
  const list = Array.isArray(props.card?.media) ? props.card.media : []
  return list.find(m => (m?.field || '').toLowerCase() === field) || null
}
const mainImage  = computed(() => mediaByField('image'))
const hoverImage = computed(() => mediaByField('hovered_image'))

/** use link as provided */
const href = computed(() => {
  const raw = props.card?.link
  return (typeof raw === 'string' && raw.trim()) ? raw : null
})

/** wrapper classes like Fluid */
const cardWrapperClasses = computed(() => ([
  'cards__card',
  'content-item',
  { '-with-button': !!props.card?.linktext, '-with-bodytext': !!props.card?.bodytext }
]))
</script>

<template>
  <div class="module-card module-card--emotional">
    <a v-if="href" :href="href" :class="cardWrapperClasses">
      <div class="card__content">
        <div class="content__image">
          <template v-if="mainImage">
            <div class="image__image hover">
              <img :src="mainImage.url" :alt="mainImage.alt || card.title || ''" :title="mainImage.title || ''" loading="lazy" />
            </div>
            <div v-if="hoverImage" class="image__image--hovered hover">
              <img :src="hoverImage.url" :alt="hoverImage.alt || card.title || ''" :title="hoverImage.title || ''" loading="lazy" />
            </div>
          </template>
        </div>
        <div class="content__title">
          <template v-if="mainImage">
            <div class="image__overlay hover">
              <img :src="mainImage.url" :alt="mainImage.alt || card.title || ''" :title="mainImage.title || ''" loading="lazy" />
            </div>
            <div v-if="hoverImage" class="image__overlay--hovered hover">
              <img :src="hoverImage.url" :alt="hoverImage.alt || card.title || ''" :title="hoverImage.title || ''" loading="lazy" />
            </div>
          </template>
          <div class="title__title--wrapper">
            <div class="title__title">
              <div class="content__text">
                <span v-if="card.subtitle" class="heading epsilon">{{ card.subtitle }}</span>
                <component :is="headerTag" class="heading beta">{{ card.title }}</component>
              </div>
              <div class="content__body">
                <div v-if="card.bodytext" class="bodytext" v-html="card.bodytext"></div>
                <div v-if="card.linktext" class="btn -btn-alpha"><span>{{ card.linktext }}</span></div>
              </div>
            </div>
            <div class="content__dark-overlay"></div>
          </div>
        </div>
      </div>
    </a>
    <div v-else :class="cardWrapperClasses">
      <div class="card__content">
        <div class="content__image">
          <template v-if="mainImage">
            <div class="image__image hover">
              <img :src="mainImage.url" :alt="mainImage.alt || card.title || ''" :title="mainImage.title || ''" loading="lazy" />
            </div>
            <div v-if="hoverImage" class="image__image--hovered hover">
              <img :src="hoverImage.url" :alt="hoverImage.alt || card.title || ''" :title="hoverImage.title || ''" loading="lazy" />
            </div>
          </template>
        </div>

        <div class="content__title">
          <template v-if="mainImage">
            <div class="image__overlay hover">
              <img :src="mainImage.url" :alt="mainImage.alt || card.title || ''" :title="mainImage.title || ''" loading="lazy" />
            </div>
            <div v-if="hoverImage" class="image__overlay--hovered hover">
              <img :src="hoverImage.url" :alt="hoverImage.alt || card.title || ''" :title="hoverImage.title || ''" loading="lazy" />
            </div>
          </template>
          <div class="title__title--wrapper">
            <div class="title__title">
              <div class="content__text">
                <span v-if="card.subtitle" class="heading epsilon">{{ card.subtitle }}</span>
                <component :is="headerTag" class="heading beta">{{ card.title }}</component>
              </div>
              <div class="content__body">
                <div v-if="card.bodytext" class="bodytext" v-html="card.bodytext"></div>
                <div v-if="card.linktext" class="btn -btn-alpha"><span>{{ card.linktext }}</span></div>
              </div>
            </div>
            <div class="content__dark-overlay"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
